var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4622 14.4738L1.42574 0.474609L0.375551 1.5276L2.94895 4.09416C1.64778 5.14148 0.622756 6.51904 0 8.09932C1.41547 11.6911 4.9091 14.2357 9.00002 14.2357C10.2249 14.2357 11.3956 14.008 12.4729 13.5928L14.412 15.5267L15.4622 14.4738ZM10.6975 11.8221L9.39411 10.5222C9.26592 10.5429 9.13442 10.5537 9.00045 10.5537C7.64634 10.5537 6.5459 9.45324 6.5459 8.09914C6.5459 7.96741 6.55631 7.83808 6.57636 7.71193L5.2727 6.41173C5.03916 6.92631 4.90909 7.4977 4.90909 8.09928C4.90909 10.3575 6.74184 12.1902 9.00002 12.1902C9.60547 12.1902 10.1803 12.0585 10.6975 11.8221ZM8.63876 5.67114L11.4294 8.45435C11.4463 8.33836 11.455 8.21976 11.455 8.09914C11.455 6.74504 10.3545 5.64459 9.00045 5.64459C8.87759 5.64459 8.75681 5.65365 8.63876 5.67114ZM13.0909 8.09932C13.0909 8.69069 12.9653 9.25288 12.7391 9.76062L15.0728 12.088C16.3637 11.0428 17.3805 9.67134 18 8.09932C16.5846 4.50747 13.095 1.96295 9.00002 1.96295C7.78629 1.96295 6.62513 2.18693 5.55522 2.59579L7.32877 4.36463C7.83911 4.13573 8.40479 4.0084 9.00002 4.0084C11.2582 4.0084 13.0909 5.84114 13.0909 8.09932Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconHide);
export default __webpack_public_path__ + "static/media/eye-icon-hide.fe422357fbcac33e6891599230580a51.svg";
export { ForwardRef as ReactComponent };